module.exports = __webpack_public_path__ + "img/5.c332dd68.png";